import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 796C645E-B8C8-4898-AE15-981077DEC280
 * name roller-shade-closed
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/roller-shade-closed.svg
 * tags
 * - Home Automation 
 */
export const RollerShadeClosedIcon = createSvgIcon(<><path d="M20 19V3H4V19H2V21H10.25C10.25 21.97 11.03 22.75 12 22.75S13.75 21.97 13.75 21H22V19H20M6 19V17H11V19H6M13 19V17H18V19H13Z" /></>, 'RollerShadeClosedIcon');
export default RollerShadeClosedIcon